/* eslint-disable */
import request from './helpers'

export function listAgent(size, page) {
  return request({
    url: '/api/v1/agent/list',
    method: 'get',
    params: {
        size, page
    }
  })
}

export function searchAgent(ip, appName, requestIp, version, size, page) {
  return request({
    url: '/api/v1/agent/search',
    method: 'get',
    params: {
        ip, appName, requestIp, version, size, page
    }
  })
}

export function deleteAgent(ids) {
  return request({
    url: '/api/v1/agent/delete',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      ids
    }
  })
}

export function batchDeleteAgent (params) {
  return request({
    url: '/api/v1/agent/delete/appNameAndUpdateTimeBefore',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json'
    },
    params
  })
}
